module.exports = __webpack_public_path__ + "static/media/arrows-upwards.25e32676.svg";